import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Process } from "./components/process";
import { FAQ } from "./components/faq";
import { ContactUs } from "./components/contactUs";
import { Contact } from "./components/contact";
import { Footer } from "./components/footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { PrivacyPolicy } from "./components/privacyPolicy";
import { TermsConditions } from "./components/termsConditions";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [data, setData] = useState({});
  const [currentView, setCurrentView] = useState("home");

  useEffect(() => {
    setData(JsonData);
  }, []);

  // Scroll to top whenever the view changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentView]);

  // Centralized navigation handler
  const handleNavigate = (targetHash) => {
    setCurrentView("home");
    // Small delay to ensure content is rendered before scrolling
    if (targetHash && targetHash !== "#page-top") {
      setTimeout(() => {
        const element = document.querySelector(targetHash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <div className="fade-in">
      <Navigation handleNavigate={handleNavigate} />
      {currentView === "home" && (
        <>
          <Header data={data.Header} />
          <About data={data.About} />
          <Services data={data.Services} />
          <Process data={data.Process} />
          <FAQ data={data.FAQ} />
          <ContactUs />
          <Contact data={data.Contact} />
        </>
      )}
      {currentView === "privacy" && <PrivacyPolicy />}
      {currentView === "terms" && <TermsConditions />}
      <Footer data={data.Footer} setCurrentView={setCurrentView} handleNavigate={handleNavigate} />
      <WhatsAppButton />
    </div>
  );
};

export default App;
